"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcRentalFormFixedAssets = void 0;
const UcRentalFormFixedAssets_yaml_component_1 = __importDefault(require("./UcRentalFormFixedAssets.yaml?component"));
exports.UcRentalFormFixedAssets = UcRentalFormFixedAssets_yaml_component_1.default;
